import React from "react";
import ReactApexChart from "react-apexcharts";

const ProfitlossChart = ({ data }) => {
  const series = [
    {
      type: "bar",
      data: (data && [Number(data[0]).toFixed(2)]) || [],
      name: "Avg. Profit",
    },
    {
      type: "bar",
      data: (data && [Number(data[1]).toFixed(2)]) || [],
      name: "Avg. Loss",
    },
  ];

  const options = {
    colors: ["#04D9FF", "#FD504F"],
    fill: {
      colors: ["#04D9FF", "#FD504F"],
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },

    plotOptions: {
      colors: {
        ranges: [
          {
            from: 0,
            to: 2100,
            color: "#9CE3A0",
          },
          {
            from: -1400,
            to: -1,
            color: "#E76C4B",
          },
        ],
      },
      columnWidth: "40%",
    },

    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: "smooth",
      width: 4,
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    xaxis: {
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      enabled: false,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const name = dataPointIndex === 0 ? "Avg. Profit" : "Avg. Loss";
        return (
          '<div class="arrow_box">' +
          "<span>" +
          name +
          "</span></br>" +
          "<span>" +
          series[seriesIndex][dataPointIndex] +
          "</span>" +
          "</div>"
        );
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart options={options} series={series} />
    </div>
  );
};
export default ProfitlossChart;
